import { JsonRpcSigner } from '@ethersproject/providers';

import { Erc20Controller } from '@bitcoin-portal/neko-web-sdk';

export const getTokenApproval = async (
  signer: JsonRpcSigner,
  tokenAddress: string,
  routerAddress: string,
  account: string,
) => {
  const tokenContract = new Erc20Controller(signer, tokenAddress);
  const allowanceRes = await tokenContract.getAllowance(account, routerAddress);
  if (allowanceRes.isFailure) throw new Error(allowanceRes.error);
  return { tokenContract, allowance: allowanceRes.getValue() };
};

export default getTokenApproval;
